export enum SECTION {
  PUBLIC = 0,
  GET_REPORT = 1,
  GET_REPORT_PRO = 2,
  PLAN_ACTION = 3,
  USER_ADMIN = 4,
  DASHBOARD = 5,
  FOLLOW_UP_INSPIRATIONS = 6,
  FOLLOW_UP = 7,
  SURVEY = 8,
  FOLLOW_UP_ACTION = 9,
  MY_FOLLOW_UP = 10,
  RESPONSE_MANAGER = 11,
}

export const INVALID_START_SECTIONS = [SECTION.SURVEY, SECTION.MY_FOLLOW_UP];

export const SECTIONS_WITH_READ_ONLY_OPTION = [
  SECTION.FOLLOW_UP,
  SECTION.FOLLOW_UP_ACTION,
];
Object.freeze(SECTIONS_WITH_READ_ONLY_OPTION);
